<template>
  <div class="secondary-row show hide-md">
    <ul id="menu">
      <li
        v-if="user === null || (user && user.role !== 'BRAND')"
        class="subheading-1"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link
          class="active-hover"
          data-test-id="header_link_brands"
          data-cy="browse-brands-link"
          to="/brands"
          @click.native="
            $ma.trackEvent({
              action: 'Navigation Click',
              properties: {
                'Page Title': 'brand directory',
                'Page Type': 'brand directory',
              },
            })
          "
        >
          Browse Brands
        </router-link>
      </li>
      <li
        v-if="user === null || (user && user.role !== 'BRAND')"
        class="subheading-1 active-hover pointer"
        data-cy="shop-categories-mouseover"
        :class="{ 'router-link-active': $route.name === 'productsFromNavigation' }"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'category')"
      >
        Shop Categories
      </li>
      <li
        v-if="user && user.role == 'BRAND'"
        class="subheading-1"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link :to="'/dashboard/products'" class="active-hover" data-cy="dashboard-link"> Dashboard </router-link>
      </li>
      <li
        v-if="user && user.role == 'BRAND'"
        class="subheading-1"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link :to="'/dashboard/orders'" class="active-hover" data-cy="orders-link">
          Orders & Shipping
        </router-link>
      </li>
      <li
        v-if="user && user.role === 'RETAILER'"
        class="subheading-1 active-hover pointer"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link
          data-test-id="header_link_redirect-favorites"
          to="/dashboard/reorder"
          @click.native="
            $ma.trackEvent({
              action: 'Navigation Click',
              properties: { 'Page Title': 'reorder', 'Page Type': 'reorder' },
            })
          "
        >
          Reorder
        </router-link>
      </li>
      <li
        v-if="shouldDisplayFeedLink"
        class="subheading-1"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link :to="'/plus'" data-cy="discovery-feed-link" class="active-hover"> Discovery Feed </router-link>
      </li>
      <li
        v-if="user && user.role === 'RETAILER'"
        class="subheading-1 active-hover pointer"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link
          data-test-id="header_link_redirect-favorites"
          to="/dashboard/favorites"
          @click.native="
            $ma.trackEvent({
              action: 'Navigation Click',
              properties: { 'Page Title': 'favorites', 'Page Type': 'favorites' },
            })
          "
        >
          Favorites
        </router-link>
      </li>

      <li
        v-if="user && user.role === 'RETAILER'"
        class="subheading-1 active-hover pointer"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link
          data-test-id="header_link_redirect-favorites"
          to="/high-sell-through"
          @click.native="
            $ma.trackEvent({
              action: 'Navigation Click',
              properties: { 'Page Title': 'bestsellers', 'Page Type': 'bestsellers' },
            })
          "
        >
          Bestsellers
        </router-link>
      </li>

      <li
        v-if="user && user.role === 'BRAND'"
        class="subheading-1 active-hover pointer"
        @mouseover="$store.dispatch('navigation/setDropdownType', 'closed')"
      >
        <router-link
          class="active-hover"
          data-test-id="header_link_messages"
          :to="{ name: 'dashboardMessages' }"
          @click.native="
            $ma.trackEvent({
              action: 'Navigation Click',
              properties: { 'Page Title': 'Messages', 'Page Type': 'Messages' },
            })
          "
        >
          Messages
        </router-link>
      </li>
      <li v-if="user && user.role === 'BRAND'" class="subheading-1 active-hover pointer">
        <a
          :class="{ 'router-link-active': $route.name === 'refer' }"
          data-test-id="header_menu_refer"
          data-cy="refer-retailer-link"
          @mouseover="$store.dispatch('navigation/setDropdownType', 'refer')"
          >Refer a Retailer</a
        >
      </li>
    </ul>
  </div>
</template>
<script>
/*
 * TODO: move getUserAccessLevel() call to the vuex store
 * then check it on session start and handlePostLogin in utils
 * remove the user watcher here
 *
 */
import { mapGetters } from "vuex";
import UserApi from "@/services/api/userApi";

const UserApiService = new UserApi();

export default {
  name: "TheNavigationBarLinks",
  computed: {
    ...mapGetters({
      user: "userState",
      plusAccess: "plusAccessState",
    }),
    shouldDisplayFeedLink() {
      // all roles or brand with access level
      return (
        (this.user !== null && this.user.role !== "BRAND") ||
        (this.user !== null && this.user.role === "BRAND" && this.plusAccess)
      );
    },
  },
  watch: {
    user: function () {
      this.getUserAccessLevel();
    },
  },
  beforeMount() {
    this.getUserAccessLevel();
  },
  methods: {
    async getUserAccessLevel() {
      if (this.user?.role === "BRAND") {
        try {
          const { data } = await UserApiService.getBulletinPlusAccess();
          this.$store.commit("setPlusAccess", data.bulletin_plus_access_level);
        } catch (err) {
          this.$bugsnagClient.notify(new Error(err));
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.secondary-row {
  ul {
    display: flex;
    justify-content: center;
    padding-bottom: 18px;

    li {
      padding: 0 10px;
      display: inline-block;
    }
  }
  .active-hover:hover,
  .router-link-active {
    background: linear-gradient(to top, #e1ffa1 40%, transparent 50%);
  }
}
</style>
